export default __webpack_public_path__ + "f51a33ab34737a3081330f1924a06a61.png";